/* eslint-disable camelcase */
import * as THREE from 'three'
import { createRectsMeshes } from '../utils/helper_functions'
import { getGeometryArray } from '../utils/getGeometryArray'

export const drawRingStanding = (group, options) => {
  const {
    x,
    y,
    width,
    height,
    inner_width: innerWidth,
    inner_height: innerHeight
  } = group
  const { color, scale, opacity = 1 } = options

  const [horizontal_w, horizontal_h] = [width, (height - innerHeight) / 2]
  const [vertical_w, vertical_h] = [(width - innerWidth) / 2, height]

  const rects = [
    {
      width: horizontal_w,
      height: horizontal_h,
      x,
      y: y + (innerHeight / 2 + horizontal_h / 2)
    },
    {
      width: horizontal_w,
      height: horizontal_h,
      x,
      y: y - (innerHeight / 2 + horizontal_h / 2)
    },
    {
      width: vertical_w,
      height: vertical_h,
      x: x + (innerWidth / 2 + vertical_w / 2),
      y
    },
    {
      width: vertical_w,
      height: vertical_h,
      x: x - (innerWidth / 2 + vertical_w / 2),
      y
    }
  ]

  const { rectMeshes, ring } = createRectsMeshes(rects, options)

  const drawRingBorder = () => {
    const lineBasicMaterial = new THREE.LineBasicMaterial({
      color,
      opacity,
      transparent: true
    })

    const geometries = [
      new THREE.PlaneGeometry(width * scale, height * scale),
      new THREE.PlaneGeometry(innerWidth * scale, innerHeight * scale)
    ]

    ring.borderLines = geometries.map((geometry) => {
      const lineGeometry = new THREE.BufferGeometry()
      const geometryArray = getGeometryArray(geometry)
      const vertices = new Float32Array(geometryArray)

      lineGeometry.setAttribute(
        'position',
        new THREE.BufferAttribute(vertices, 3)
      )
      const line = new THREE.Line(lineGeometry, lineBasicMaterial)
      ring.add(line)
      return line
    })
  }

  drawRingBorder()

  return { standingArea: ring, rectMeshes }
}
